import React, { Component, Fragment } from 'react';
import { routerShape } from 'react-router';
import LazyHydrate from 'react-lazy-hydration';
import scrollToComponent from 'react-scroll-to-component-ssr';
import { JsonLd } from 'react-schemaorg';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';
import { UserProp } from 'auth';
import Perms from 'auth/perms';
import apiDecorator from 'api/api-decorator';
import DataProvider from 'api/data-provider';
import { reportError } from 'api/api-errors';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import { emit } from 'helpers/global-events';
import noScroll from 'helpers/noScroll';
import absoluteUrl from 'helpers/absoluteUrl';
import Counter from 'subsys/counter';
import Subscribe from 'subsys/notifications/subscribe';
import { FavoritesButton, FavoriteWrapper } from 'subsys/favorites';
import Paginator, { Control, Container, Pages } from 'components/paginator';
// import Block, { BlockHeader, BlockContent } from 'components/block';
// import { ModalButton, Header, Content } from 'components/modal';
// import SearchLayout from 'components/search-layout';
import Button, { btnViews } from 'components/button';
import Icon, { iconTypes } from 'components/icon';
import Row, { Col } from 'components/row';
import Link from 'components/link';
import AdSense from 'components/adsense';
import { SearchInput } from 'components/header';
import sensor from 'components/sensor';
import Notification from 'components/notification';
import Image, { OpenGraphImage } from 'components/image';
import Slick from 'components/slick-slider';

import config from 'src-sites/forum/const-config';
import getHeaderHeight from 'src-sites/forum/common/get-header-height';
import linksForum from 'src-sites/forum/links';
import linksDomik from 'src-sites/domik/links';
import { getImages } from 'src-sites/domik/section-project/get-images';

import { withPostEditing } from './with-post-editing';
import AdminPanel from './admin/panel';
import ForumTopicAdd from './forum-topic-add';
import VoteBlock from './voting';
import ReplyPostButton from './reply-post-button';
import Posts from './posts';
import SliderProvider from './slides/slider-provider';
// import StatisticsBlock from './statistics';
import AddForumNick from './add-forum-nick';
import ShowRulesList from './show-rules-list';
// import UserForumActivity from './user/user-forum-activity';
// import ContestTopicAdd from '../contest/contest-topic-add';
import BlockLC from '../forums/block-lc';

import translates from '../forum-i18n';

import 'styles/forum/section-forum/_page-forum.scss';

const { limitCountPost } = config;

const bemClasses = new Bem('forum');
// const bemClassesAdminPane = new Bem('adminPanelForum');
// const classesBemForm = new Bem('modalContentAdmin');
const bemClassesRegistryInvestor = new Bem('registryInvestor');
const bemClassesTopicInfo = new Bem('topicInfo');
const bemClassesPosts = new Bem('postList');
const bemClassesTags = new Bem('tags');
// const blockClasses = new Bem('block');

// Show info about topic.
@withPostEditing
@apiDecorator
@sensor
@I18nHoc(translates())
export default class TopicInfo extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    checkPermission: PropTypes.func,
    params: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      search: PropTypes.string,
      page: PropTypes.string,
      post: PropTypes.string
    }),
    router: routerShape,
    getForumId: PropTypes.func,
    onHandleSelectPost: PropTypes.func,
    onHandleDeletePost: PropTypes.func,
    renderSearchContentBlock: PropTypes.func,
    selectedPosts: PropTypes.arrayOf(PropTypes.shape({})),

    // Preloaded data
    preloadedPosts: PropTypes.shape({}),
    preloadedVoting: PropTypes.shape({}),
    preloadedAds: PropTypes.shape({}),
    preloadedRulesList: PropTypes.shape({}),
    preloadedNewbuildBlock: PropTypes.any, // eslint-disable-line
    mainDeveloper: PropTypes.any, // eslint-disable-line
    preloadedLcStructure: PropTypes.arrayOf(PropTypes.shape({})),
    landingLc: PropTypes.shape({}),
    preloadedTagsSlider: PropTypes.shape({}),
    search: PropTypes.string
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.showAuthorData = this.showAuthorData.bind(this);
    this.renderFavoriteButton = this.renderFavoriteButton.bind(this);
    this.onHandleResize = this.onHandleResize.bind(this);
    this.onResize = this.onHandleResize;
    this.needCount = true;
    this.delay = null;

    this.state = {
      needForumNick: false,
      showBottomPost: false,
      search: null
    };
  }

  // Set forum id.
  componentWillMount() {
    const { data = [] } = this.props;
    const dataObj = data[0] || {};
    this.props.getForumId(dataObj.forum_id);
  }

  // Make save time for this topic for auth user
  componentDidMount() {
    const { auth = {}, data = [] } = this.props;
    const dataObj = data[0] || {};

    if (auth.authenticated) {
      this.delay = setTimeout(() => saveTime.call(this, dataObj.topic_id), 15000);
    }
    this.onHandleResize(this.sensor.getRuntime());
  }

  componentDidUpdate(prevProps) {
    const { auth = {}, params = {} } = this.props;
    const { needForumNick, showBottomPost } = this.state;
    this.needCount = false;
    this.onHandleResize(this.sensor.getRuntime());

    if (
      (!auth.authenticated && auth.authenticated !== prevProps.auth.authenticated) ||
      (auth.authenticated && auth.authenticated !== prevProps.auth.authenticated)
    ) {
      emit('updateVote');
      emit('updateClubPosts');
      emit('updatePosts');
    }
    if (!auth.forum_nick && auth.forum_nick && showBottomPost) this.replyAfterLogin();

    if (auth.authenticated && !prevProps.auth.authenticated && needForumNick) {
      if (!auth.forum_nick) return this.setState({needForumNick: true, showBottomPost: false});
      this.setState({needForumNick: false, showBottomPost: true});
      this.scrollTo(this.newPost);
    }
    if (get(prevProps, 'params.url') !== get(this, 'props.params.url')) this.needCount = true;
  }

  componentWillUnmount() {
    clearTimeout(this.delay);
  }

  renderImages =(data)=> {
    if (!data || !data.length) return null;

    const forum_title = get(this, 'props.data[0].forum_title');

    return (
      <Row {...bemClassesTopicInfo('row', 'topic')} allColumn>
        <Col {...bemClassesTopicInfo('col', 'img')} allPr={0}>
          <div {...bemClassesTopicInfo('img')}>
            <Slick {...bemClassesTopicInfo('imgPic')}>
              {map(data, (img, index) => (
                <Fragment key={index}>
                  <Image
                    image={getImages.call(this, img, { alt: forum_title, title: forum_title }).titleImage}
                    group="topicImages"
                  />
                  <JsonLd
                    item={{
                      '@context': 'https://schema.org',
                      '@type': 'ImageObject',
                      name: forum_title || null,
                      description: forum_title || null,
                      contentUrl: img ? absoluteUrl(`/images/thumb/full/${img}`) : null
                    }}
                  />
                </Fragment>
              ))}
            </Slick>
          </div>
        </Col>
      </Row>
    );
  }

  onHandleResize({ media: { desktop, tablet, phone } = {} }) {
    const { device } = this.state;

    if (desktop && device !== 'desktop') return this.setState({ device: 'desktop' });
    if (tablet && device !== 'tablet') return this.setState({ device: 'tablet' });
    if (phone && device !== 'phone') return this.setState({ device: 'phone' });
  }

  scrollTo(ref) {
    const headerHeight = getHeaderHeight.call(this);
    scrollToComponent(ref, { offset: -headerHeight, align: 'top', duration: 300, ease: 'linear' });
  }

  afterItemsContent =()=> {
    const { renderSearchContentBlock } = this.props;

    const arrSearchContentBlock = !renderSearchContentBlock ?
      null : [
        renderSearchContentBlock('blockTAdvert3'),
        renderSearchContentBlock('blockTAdvert15')
      ];

    return [
      ...arrSearchContentBlock,
      <AdSense />
    ];
  };

  // Show info about user for forum. For club show list of tags.
  showAuthorData(data = {}) {
    if (
      (!data.tagsFirst || !data.tagsFirst.length) &&
      (!data.tagsEnd || !data.tagsEnd.length)
    ) return null;

    // Show all tags for this topic.
    return (
      <div {...bemClassesTopicInfo('tagsContainer')}>
        <span {...bemClassesTags({ extra: this.props.className })}>
          {data.tagsFirst &&
          map(data.tagsFirst, (item, index) => (
            <span
              {...bemClassesTags('item')}
              key={`tag-first-${index}`}
            >
              <Link
                {...bemClassesTags('link', `asBtn tag ${item.color ? item.color : ''}`)}
                builder={linksForum.sectionTags}
                builderProps={item}
              >
                <span {...bemClassesTags('linkContent')}>
                  <span {...bemClassesTags('text')}>{item.name}</span>
                </span>
              </Link>
            </span>
          ))}
          {data.tagsEnd &&
          map(data.tagsEnd, (item, index) => (
            <span
              {...bemClassesTags('item')}
              key={`tag-first-${index}`}
            >
              <Link
                {...bemClassesTags('link', 'asBtn tag')}
                builder={linksForum.sectionTags}
                builderProps={item}
              >
                <span {...bemClassesTags('linkContent')}>
                  <span {...bemClassesTags('text')}>{item.name}</span>
                </span>
              </Link>
            </span>
          ))}
        </span>
      </div>
    );
  }

  topicInfoContent(dataObj) {
    const { i18n } = this;
    const { router, auth, checkPermission } = this.props;

    return (
      <>
        {dataObj.showEditButton &&
          <ForumTopicAdd
            {...bemClasses('btn', 'edit')}
            forum_id={dataObj.forum_id}
            topic_id={dataObj.topic_id}
            router={router}
            auth={auth}
            checkPermission={checkPermission}
            modalBtnProps={{
              iconType: iconTypes.edit,
              title: i18n('changeTopicPolls'),
              label: i18n('edit')
            }}
            modalSize="content"
            modalHeaderTitle={i18n('changeTopicPolls')}
          />
        }
        {this.renderPostsList()}
        {/*
        <Block>
          <BlockHeader
            headerLeft={
              <SearchLayout
                params={params}
                router={router}
                routeProps={{ topicUrl: params.title, id: params.id }}
                linkSearch={linksForum.sectionTopicSearch}
                placeholder="Поиск в теме"
                counterProps={{
                  mode: 'click',
                  entity: {
                    topic_id: dataObj.topic_id
                  },
                  action: 'searchClick'
                }}
                desktop
              >
                <div {...blockClasses('headerTopic')}>
                  <div {...blockClasses('headerTopicLeft')}>
                    <div {...blockClasses('text')}>
                      <h1 children={dataObj.topic_title} />
                    </div>
                  </div>
                </div>
              </SearchLayout>
            }
            headerRight={
              <>
                {dataObj.allRules && dataObj.forum_type === 'contest' &&
                  <ContestTopicAdd
                    {...bemClassesTopicInfo('btnEdit')}
                    forum_id={dataObj.forum_id}
                    topic_id={dataObj.topic_id}
                    router={this.props.router}
                    modalBtnProps={{
                      iconType: iconTypes.edit,
                      title: 'Изменить конкурс / Опросы',
                      iconOnly: true
                    }}
                    modalSize="content"
                    modalHeaderTitle="Изменить конкурс / Опросы"
                  />
                }
              </>
            }
          />
          <BlockContent noPaddingLR>
            {this.showAuthorData(dataObj)}
          </BlockContent>
        </Block>
        */}
      </>
    )
  }

  onClickNewPostButton =()=> {
    const { auth, actionDoLogin, data, checkPermission } = this.props;
    if (
      checkPermission(Perms.FORUM_PREMODERATION_POST) &&
      !checkPermission(Perms.FORUM_CONTROL_PREMODERATION_POST) &&
      get(data, '[0].ban_posts')
    ) {
      return this.banPosts();
    }

    if (!auth.forum_nick) this.setState({
      needForumNick: true,
      showBottomPost: false
    });
    if (auth.forum_nick) {
      this.setState({
        needForumNick: false,
        showBottomPost: true
      });
      this.scrollTo(this.newPost);
    }

    if (!auth.authenticated && typeof actionDoLogin === 'function') return actionDoLogin();
  }

  replyAfterLogin =()=> {
    this.setState({
      needForumNick: false,
      showBottomPost: true
    })
  }

  onCloseModalForumNick =()=> {
    this.setState({needForumNick: false});
    noScroll(false);
  }

  closeReplyPost =()=> {
    this.setState({showBottomPost: false})
  }

  onPostSubmit =(scrollToPostId = null)=> {
    const changedStates = {needForumNick: false, showBottomPost: false};
    if (scrollToPostId) changedStates.scrollToPostId = scrollToPostId;
    this.setState(changedStates);
  }

  banPosts () {
    Notification.warning(this.i18n('cannotReplyTheme'));
  }

  renderNewPost =(data)=> {
    const { showBottomPost } = this.state;
    const { params, router } = this.props;

    return (
      <>
        <div ref={el => this.newPost = el} />
        {showBottomPost &&
          <div {...bemClassesPosts('quotePostContainer', 'newPost')}>
            <Button
              {...bemClassesPosts('btn', 'close')}
              iconType={iconTypes.clear}
              title={this.i18n('btnClose')}
              onClick={this.closeReplyPost}
              //iconOnly={true}
            />
            <ReplyPostButton
              {...bemClassesPosts('quotePost')}
              params={params}
              router={router}
              onPostSubmit={this.onPostSubmit}
              data={data}
            />
          </div>
        }
      </>
    )
  }

  renderNewPostButton(dataObj = {}) {
    const { i18n } = this;
    const { needForumNick, showBottomPost } = this.state;

    if (dataObj.topicIsOpen && !!dataObj.forum_type) {
      return (
        <>
          <Button
            {...bemClasses('btn', { reply: true, disabled: showBottomPost })}
            title={i18n('reply')}
            label={i18n('reply')}
            dataView={btnViews.float}
            onClick={this.onClickNewPostButton}
            // classNameModal={bemClassesAdminPane('modal', 'reply').className}
          />
          {needForumNick &&
            <AddForumNick
              onCloseModalForumNick={this.onCloseModalForumNick}
              functionIsLogin={this.replyAfterLogin}
            />
          }
        </>
      );
    }
  }

  onSearchChange = (search) => {
    this.setState({ search })
  }

  renderPostsList() {
    const { i18n } = this;
    const { scrollToPostId } = this.state;
    const {
      params = {}, router, preloadedPosts, data: [dataObj = {}] = [], search, auth, actionDoLogin,
      checkPermission, onHandleSelectPost, selectedPosts, onHandleDeletePost, postsQuery
    } = this.props;

    const isFirstPage = +get(postsQuery, 'offset', 0) === 0;
    const banPosts = get(dataObj, 'ban_posts');
    const { landing = {} } = params;
    const { offset } = landing;
    const page = (offset/limitCountPost)+1;

    const cSubscribe = (
      <Subscribe
        {...bemClasses('subscribe')}
        updateEvent="toggleSubscribe"
        mode="active"
        labelSubscribe={i18n('subscribeTheme')}
        labelUnsubscribe={i18n('unsubscribeTheme')}
        type="forumReply"
        entity="topic"
        entity_id={parseInt(dataObj.topic_id)}
      />
    );
    const cFavorite = (
      <FavoriteWrapper
        project="forum"
        entity="publication"
      >
        {favData => this.renderFavoriteButton(favData)}
      </FavoriteWrapper>
    );
    const elementsRight = (
      <Row {...bemClasses('row', 'pagesAside')}>
        <Col {...bemClasses('col', 'search')} allAuto allPr={0}>
          <SearchInput
            {...bemClasses('search', 'paginator')}
            params={params}
            router={router}
            linkBuilder={linksForum.sectionForumTopics}
            builderProps={{ forumUrl: dataObj.topicUrl }}
            search={this.state.search || search}
            onSearchChange={this.onSearchChange}
            queryParamName="search"
            placeholder={i18n('searchInTopic')}
          />
        </Col>
        <Col {...bemClasses('col', 'btn')} allAuto allPr={0}>
          {this.renderNewPostButton(dataObj)}
        </Col>
      </Row>
    )

    return (
      <>
        <div {...bemClasses('paginatorWrapper', 'before')}>
          {cSubscribe}
          {cFavorite}
        </div>
        <Paginator
          updateEvent="updateClubPosts"
          url="forum/post"
          query={postsQuery}
          queryJson
          limit={limitCountPost}
          changeUrl
          page={page}
          preloaded={preloadedPosts}
          withTopPages
          noData={
            <div {...bemClasses('pages')}>
              {elementsRight}
              <div children={i18n('noDataText')} />
            </div>
          }
        >
          <Control addPaddingLR />
          <Container
            {...bemClasses('list')}
            injectPropName="object"
            afterItemsContent={this.afterItemsContent}
          >
            <Posts
              params={params}
              router={router}
              scrollToPostId={scrollToPostId}
              auth={auth}
              actionDoLogin={actionDoLogin}
              checkPermission={checkPermission}
              onHandleSelectPost={onHandleSelectPost}
              selectedPosts={selectedPosts}
              onHandleDeletePost={onHandleDeletePost}
              userStatus={{
                forum_type: dataObj.forum_type,
                allRules: dataObj.allRules,
                clubUserStatus: dataObj.clubUserStatus
              }}
              banPosts={banPosts}
              search={!!search}
              isFirstPage={isFirstPage}
              onPostSubmit={this.onPostSubmit}
            />
          </Container>
          <Pages
            {...bemClasses('pages')}
            linkBuilder={linksForum.sectionTopic}
            linkBuilderProps={{
              paramsTitle: params.title,
              id: params.id,
              forum_type: dataObj.forum_type,
              topicUrl: dataObj.topicUrl,
              search
            }}
            router={router}
            // withPageChange
            pagesRow
            search={this.state.search}
            elementsRight={elementsRight}
          />
        </Paginator>
        {this.renderNewPost(dataObj)}
        <div {...bemClasses('paginatorWrapper', 'after')}>
          {cSubscribe}
          {cFavorite}
        </div>
      </>
    );
  }

  renderFavoriteButton({ data }) {
    const entity_id = +get(this, `props.data[0].topic_id`);

    if (!entity_id) return null;

    const index = findIndex(data, { entity_id });

    return (
      <FavoritesButton
        {...bemClasses('favorites')}
        project="forum"
        entity="publication"
        entityId={entity_id}
        subgroup="forum_topic"
        inFavorites={index > -1}
      />
    );
  }

  countInvestors =({ dataCount })=> {
    return `\u0020${dataCount || 0}`;
  }

  render() {
    const { i18n } = this;
    const {
      className, data = [], auth, actionDoLogin, params,
      preloadedVoting = {}, preloadedLcStructure, landingLc,
      preloadedNewbuildBlock, preloadedTagsSlider = {}, mainDeveloper,
      preloadedRulesList
    } = this.props;
    const dataObj = data[0] || {};
    const lcUrl = get(preloadedNewbuildBlock, 'url');
    const pageUrl = get(params, 'url');
    const lcAddress = get(preloadedNewbuildBlock, 'fullAddress.address');
    const topicClose = !dataObj.topicIsOpen ? (
      <div {...bemClasses('titleDesc')}>
        <span {...bemClasses('text')}>
          <p children={i18n('lockedTheme')} />
        </span>
      </div>
    ) : null;
    const locationId = get(preloadedLcStructure, '[0].lc_id');
    let opgImageId = null;
    if (dataObj.lc_id && get(preloadedNewbuildBlock, 'product.addition_fields.topic_lc')) {
      opgImageId = get(preloadedNewbuildBlock, 'images.others[0].id');
    }
    const opgProps = {};
    if (opgImageId) opgProps.imageId = opgImageId;
    let topicCounter = null;
    if (this.needCount) {
      const entity = { topic_id: dataObj.topic_id };
      if (!!dataObj.lc_id) entity.project_id = dataObj.lc_id
      topicCounter = (
        <Counter
          mode="view"
          entity={entity}
          action="pageTopicView"
        />
      );
    }

    return (
      <Col mtColumn mpColumn mdAdjust={330} allPr={0}>
        <div {...bemClassesTopicInfo({ extra: className })}>
          <div>
            <LazyHydrate ssrOnly>
              <OpenGraphImage
                {...opgProps}
              />
            </LazyHydrate>
            {/*
            <UserForumActivity forumId={dataObj.forum_id} topicId={dataObj.topic_id} />
            <AdProvider
              treeId={`${dataObj.tree}-${dataObj.forum_type}`}
              preloaded={preloadedAds}
              trackAs="club"
            />
            */}
            <ShowRulesList
              tree={dataObj.tree}
              preloaded={preloadedRulesList}
              trackAs="club"
              rulesFor="клуба"
            />
            <Row {...bemClasses('row', 'topic')}>
              {dataObj.topic_title &&
                <Col {...bemClasses('col', 'title')} allPr={0}>
                  <div {...bemClasses('title')}>
                    <div {...bemClasses('text', 'h1')}>
                      <h1 children={dataObj.topic_title} />
                    </div>
                    {topicClose}
                  </div>
                </Col>
              }
            </Row>
            {this.renderImages(dataObj.images)}
            <Row {...bemClasses('row', 'topicAfter')} mpColumn>
              <Col {...bemClasses('col', 'address')} allPr={0}>
                {!!dataObj.lc_id && lcUrl &&
                  <Link
                    {...bemClasses('link', 'address')}
                    builder={linksDomik.sectionLanding}
                    builderProps={{ url: `${lcUrl}#map`, title: lcAddress }}
                    title={lcAddress}
                    noRedirector
                  >
                    <span {...bemClasses('linkContent')}>
                      <Icon {...bemClasses('icon')} type={iconTypes.marker} />
                      <span {...bemClasses('text')} children={lcAddress} />
                    </span>
                  </Link>
                }
              </Col>
              {!!dataObj.lc_id &&
                <Col {...bemClasses('col', 'registryInvestor')} allAuto allPr={0} mdPl={10} mtPl={10}>
                  <Link
                    {...bemClassesRegistryInvestor('link', 'registryInvestor')}
                    builder={linksForum.sectionInvestorRegistry}
                    builderProps={{ ...dataObj, title: i18n('investorRegister') }}
                    title={i18n('investorRegister')}
                  >
                    <span {...bemClassesRegistryInvestor('linkContent')}>
                      <span {...bemClassesRegistryInvestor('text')}>
                        {i18n('investorRegister')}
                        <DataProvider
                          url="forum/investor-registry/investor-registry"
                          query={{
                            locationId: dataObj.lc_id,
                            countOnly: true
                          }}
                          tagSpan
                          renderer={this.countInvestors}
                        />
                      </span>
                    </span>
                  </Link>
                </Col>
              }
            </Row>
            {!!dataObj.lc_id &&
              <BlockLC
                data={preloadedNewbuildBlock}
                mainDeveloper={mainDeveloper}
                landingLc={landingLc}
                pageUrl={pageUrl}
              />
            }
            {/*
            <SliderProvider
              url="advertisement/newbuilds-ad"
              queryWord="forumId"
              id={dataObj.topic_id}
              preloaded={preloadedNewbuildBlock}
            />
            */}
            <VoteBlock
              topicId={dataObj.topic_id}
              forumType={dataObj.forum_type}
              auth={auth}
              actionDoLogin={actionDoLogin}
              preloaded={preloadedVoting}
            />
          </div>
          {this.topicInfoContent(dataObj, auth)}
          {dataObj.tagsEnd && !!dataObj.tagsEnd.length &&
            <div>
              {map(dataObj.tagsEnd, (tag, index) => (
                <SliderProvider
                  key={tag.link}
                  url="forum/tag-slider-ad"
                  queryWord="tag"
                  id={tag.link}
                  preloaded={preloadedTagsSlider[`tagSlider${index}`]}
                />
              ))}
            </div>
          }
          {topicCounter}
          {dataObj.allRules &&
            <AdminPanel
              selectedItems={this.props.selectedPosts}
              onHandleDelete={this.props.onHandleDeletePost}
              onResetSelection={this.props.onHandleSelectPost}
              entity="posts"
            />
          }
          {/*
          <div>
            <StatisticsBlock topicId={dataObj.topic_id} forumId={dataObj.forum_id} />
          </div>
          */}
        </div>
      </Col>
    );
  }
}

export function saveTime(topicId) {
  this.api.post('action/forum/actions-read-topics/read', {
    postData: {
      topicId
    }
  })
    .catch(error => reportError(error));
}
